import * as yup from "yup"

export const schemaInfoWorking = yup.object().shape({
  totalClip: yup
    .string()
    .required("Nhập số lượng video")
    .test("totalClip", "Số lượng video phải từ 1 đến 3", (value: string) => {
      const numberValue = Number(value)
      return numberValue >= 1 && numberValue <= 3
    }),
  sku: yup.string().optional(),
  contentType: yup.array().required("Chọn hình thức lên bài"),
  addressInfo: yup.string().optional()
})

export const schemaRequestSample = yup.object().shape({
  phoneNumber: yup
    .string()
    .required("Vui lòng nhập số điện thoại.")
    .test("phoneNumber", "Vui lòng nhập số điện thoại hợp lệ.", (phoneNumber: string) => {
      const reg = /((84|0[3|5|7|8|9])+([0-9]{8})\b)|(1[8|9]00)+([0-9]{4}\b)/g
      return !!reg.test(phoneNumber)
    }),
  address: yup.string().required("Nhập địa chỉ nhận hàng."),
  fullName: yup.string().required("Nhập họ và tên."),
  provinceCode: yup.string().required("Tỉnh/Thành phố là bắt buộc"),
  districtCode: yup.string().required("Quận/Huyện là bắt buộc"),
  wardCode: yup.string().required("Phường/Xã là bắt buộc"),
  isDefault: yup.boolean().optional(),
  warning: yup.string()
})

export const schemaApplyCampaignForm = yup.object().shape({
  addressInfo: yup.object().shape({
    address: yup.string().optional(),
    phoneNumber: yup.string().optional(),
    fullName: yup.string().optional(),
    provinceCode: yup.string().optional(),
    districtCode: yup.string().optional(),
    wardCode: yup.string().optional(),
    isDefault: yup.boolean().optional()
  }),
  addressEditInfo: yup.object().shape({
    address: yup.string().optional(),
    phoneNumber: yup.string().optional(),
    fullName: yup.string().optional(),
    provinceCode: yup.string().optional(),
    districtCode: yup.string().optional(),
    wardCode: yup.string().optional(),
    isDefault: yup.boolean().optional()
  }),
  contentTypes: yup
    .array()
    .of(yup.string())
    .min(1, "Vui lòng chọn ít nhất một hình thức (Video hoặc Livestream)"),
  totalClip: yup.string().required("Vui lòng chọn số lượng video/livestream")
})
